import { useInfiniteQuery } from '@tanstack/react-query';
import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import { Box } from 'styled-system/jsx';
import FileList from '@/modules/FileList/components/fileList/FileList.tsx';
import { newFilesListQueryOptions } from '@/modules/FileList/queries/newFilesList/newFilesListQueryOptions.ts';
import LoadingPage from '@/common/pages/LoadingPage.tsx';
import ListFilter from '@/modules/FileList/components/listFilterSection/ListFilter';
import useFilterChips from '@/modules/FileList/hooks/useFilterChips';
import useFilterQueryParams from '@/modules/FileList/hooks/useFilterQueryParams';
import { useEffect } from 'react';

export default () => {
  return (
    <MainLayout title="پیشنهاد کارشناسی" header="onlyTitleHeader" navbar>
      <InProgressListPage />
    </MainLayout>
  );
};

const InProgressListPage = () => {
  const { fileListParams, resetQueryParams } = useFilterQueryParams();
  const { data, fetchNextPage, isError, isPending } = useInfiniteQuery(
    newFilesListQueryOptions(fileListParams),
  );
  const filterChipsList = useFilterChips();

  useEffect(() => {
    resetQueryParams();
  }, []);
  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }

  return (
    <Box pt="20px">
      <ListFilter
        filterChipsList={filterChipsList}
        hasDateOrFileState={false}
      />
      {data ? (
        <FileList fetchNextPage={fetchNextPage} myFilesData={data} />
      ) : null}
    </Box>
  );
};
